<template>
  <div id="ht-wrap"></div>
</template>

<script>
export default {
name: "conferenceRoom",
  data(){
    return {
      dataModel: null,          //数据容器//公共方法属性
      graphView: null,           //2D
      g3d: null,
      dm: null,
      menu_index: '',

      uData: 0,
      iData: 0,
      pData: 0,//功率
      qData: 0,//总有功电度
      phi: 0,//功率因数
      wData: 0,//总无功电度

      screenTopLight: '0',//幕布前筒灯
      quadrangleLight: '0',//四角筒灯
      aroundLight: '0',//四周筒灯
      bothLight: '0',//两侧射灯
      centerLight: '0',//中间射灯
      mantleCenterLight: '0',//软膜灯中
      mantleTopLight: '0',//软膜灯前
      mantleBackLight: '0',//软膜灯后

      ktStatus: '0',//空调的开关状态

      isMantleTopLight: '0',//前软膜灯状态
      isCenterLight: '0',//中间射灯状态
      isScreenTopLight: '0',//幕布前筒灯状态
      isDownFlushLight: '0',  //外圈筒灯
      isMantleBackLight: '0',//软膜灯后状态
      isMantleCenterLight: '0',//软膜灯中状态
      isBothLight: '0',//两侧射灯状态
      isQuadrangleLight: '0',//四角筒灯状态
      isRollingStatus: '0',//窗帘状态
      isScreenStatus: '0',//幕布状态


      timer: '',
      TG_NAME: 'TG271',
      elevatorTask_r: null,
      beforeSwitchStatus: '',
      //$md5: 'd0e1e2dc9473cdb301f7e97de3bda3cd',
    }
  },
  beforeCreate() {
    window.htUrl('ht-conferenceRoom');
  },
  mounted() {
    this.getData();
    this.interval();
    // this.addGraphView()
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    addGraphView() {
      this.dataModel = new ht.DataModel();  // 数据容器
      this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
      this.dm = this.graphView.dm();

      //graphView.addToDOM(this.$el);  //将元素加入到指定的dom 元素下，不指定加入到document.body 下

      let _this = this;
      this.g3d = new ht.graph3d.Graph3dView();         //3d
      this.g3d.addToDOM(document.getElementById('ht-wrap'));
      this.g3d.deserialize('scenes/3d会议室.json', function (json, dm, g3d, datas) {
        g3d.setEye(-651, 124, -12);
        g3d.setCenter(184, 113, -10);//目标
      });
      this.graphView.deserialize('displays/demo/3D会议室/3D会议室.json', function (json, dm, g3d, datas) {
        let table1 = dm.getDataByTag('table1'), table2 = dm.getDataByTag('table2');
        let table1Columns = [
          {
            "displayName": "电压(V)",
            "align": "center",
            "key": "username",
            "width": 140,
            "headColor": "#ffffff"
          },
          {
            "displayName": _this.uData,
            "align": "center",
            "key": "sex",
            "width": 0.1,
            "bodyColor": "#ffffff"
          },
          {
            "displayName": "电流(A)",
            "align": "center",
            "key": "userAge",
            "width": "90+0.1",
            "color": "#ffffff"
          },
          {
            "displayName": _this.iData,
            "align": "center",
            "key": "address",
            "width": 100
          }
        ], table2Columns = [
          {
            "displayName": "幕布前筒灯(mA)",
            "align": "center",
            "key": "username",
            "width": 160,
            "headColor": "#ffffff"
          },
          {
            "displayName": _this.screenTopLight,
            "align": "center",
            "key": "sex",
            "width": 0.1,
            "bodyColor": "#ffffff"
          },
          {
            "displayName": "四角筒灯(mA)",
            "align": "center",
            "key": "userAge",
            "width": "70+0.1",
            "color": "#ffffff"
          },
          {
            "displayName": _this.quadrangleLight,
            "align": "center",
            "key": "address",
            "width": 100
          }
        ];
        let table1Data = [
          {
            "username": "功率(kW)",
            "userAge": "总有功电度(kWh)",
            "sex": _this.pData,
            "address": _this.qData
          },
          {
            "username": "功率因数",
            "userAge": "总无功电度(kWh)",
            "sex": _this.phi,
            "address": _this.wData
          },
          {
            "username": "",
            "userAge": "",
            "sex": "",
            "address": ""
          }
        ], table2Data = [
          {
            "username": "四周筒灯(mA)",
            "userAge": "两侧射灯(mA)",
            "sex": _this.aroundLight,
            "address": _this.bothLight
          },
          {
            "username": "中间射灯(mA)",
            "userAge": "软膜灯中(mA)",
            "sex": _this.centerLight,
            "address": _this.mantleCenterLight
          },
          {
            "username": "软膜灯前(mA)",
            "userAge": "软膜灯后(mA)",
            "sex": _this.mantleTopLight,
            "address": _this.mantleBackLight
          }
        ];
        table1.a('table.columns', table1Columns);  //修改数据绑定的值
        table1.a('table.dataSource', table1Data)
        table2.a('table.columns', table2Columns);  //修改数据绑定的值
        table2.a('table.dataSource', table2Data);
        _this.getStatus();
      });
      this.graphView.addToDOM(this.g3d.getView());
      this.graphView.mi(this.handleInteractive2d);
      // 禁止所有缩放
      this.graphView.setZoomable(false)
      // 左键可拖拽编辑图元，右键可改变视角方向，采用这样的方式一般会结合键盘w|s|a|d按键进行漫游操作
      this.g3d.setMouseRoamable(false);

      ht.Default.graph3dViewMaxPhi=Math.PI //最大角度
      ht.Default.graph3dViewMinPhi=0 //最小角度
    },

    interval(){
      let _this = this;
      this.timer = setInterval(function () {
        _this.getPopData();
      }, 3000)
    },

    // 获取刷新数据
    getPopData() {
      this.$get('conferenceroom/meetingroom', {})
          .then((response) => {
            this.uData = response.airData["TG271:c2_b1:u"].val;
            this.iData = response.airData["TG271:c2_b1:i"].val;
            this.pData = response.airData["TG271:c2_b1:p"].val;
            this.qData = response.airData["TG271:c2_b1:ep"].val;
            this.wData = response.airData["TG271:c2_b1:eq"].val;
            this.phi = response.airData["TG271:c2_b1:pf"].val;
            this.ktStatus = response.airData["TG271:c1_b2:di"].val;//空调状态

            this.screenTopLight = response.lampData["TG271:c1_b3:i-td-mbq"].val;
            this.quadrangleLight = response.lampData["TG271:c1_b4:i-td-sj"].val;
            this.aroundLight = response.lampData["TG271:c1_b3:i-td-w"].val;
            this.bothLight = response.lampData["TG271:c1_b4:i-sd-w"].val;
            this.centerLight = response.lampData["TG271:c1_b3:i-sd-zj"].val;
            this.mantleCenterLight = response.lampData["TG271:c1_b4:i-rmlight-zj"].val;
            this.mantleTopLight = response.lampData["TG271:c1_b3:i-rmlight-q"].val;
            this.mantleBackLight = response.lampData["TG271:c1_b4:i-td-h"].val;

            //状态
            this.isMantleTopLight = response.diStatusData["TG271:c1_b5:di-rmlight-q"].val;//前软膜灯
            this.isCenterLight = response.diStatusData["TG271:c1_b5:di-sd-zj"].val;//中间射灯
            this.isScreenTopLight = response.diStatusData["TG271:c1_b5:di-td-mbq"].val;//幕布前筒灯
            this.isDownFlushLight = response.diStatusData["TG271:c1_b5:di-td-w"].val;//外圈筒灯
            this.isMantleBackLight = response.diStatusData["TG271:c1_b6:di-rmlight-h"].val;//软膜灯后
            this.isMantleCenterLight = response.diStatusData["TG271:c1_b6:di-rmlight-zj"].val;//软膜灯中
            this.isBothLight = response.diStatusData["TG271:c1_b6:di-sd-w"].val;//两侧射灯
            this.isQuadrangleLight = response.diStatusData["TG271:c1_b6:di-td-sj"].val;//四角筒灯
            this.isRollingStatus = response.diStatusData["TG271:c1_b7:di-cl"].val;//窗帘状态
            this.isScreenStatus = response.diStatusData["TG271:c1_b8:di-mb"].val;//幕布状态

          }).catch((response) => {
        console.log(response);
      });
    },

    // 获取数据
    getData() {
      this.$get('conferenceroom/meetingroom', {})
          .then((response) => {

            this.uData = response.airData["TG271:c2_b1:u"].val;
            this.iData = response.airData["TG271:c2_b1:i"].val;
            this.pData = response.airData["TG271:c2_b1:p"].val;
            this.qData = response.airData["TG271:c2_b1:ep"].val;
            this.wData = response.airData["TG271:c2_b1:eq"].val;
            this.phi = response.airData["TG271:c2_b1:pf"].val;

            this.screenTopLight = response.lampData["TG271:c1_b3:i-td-mbq"].val;
            this.quadrangleLight = response.lampData["TG271:c1_b4:i-td-sj"].val;
            this.aroundLight = response.lampData["TG271:c1_b3:i-td-w"].val;
            this.bothLight = response.lampData["TG271:c1_b4:i-sd-w"].val;
            this.centerLight = response.lampData["TG271:c1_b3:i-sd-zj"].val;
            this.mantleCenterLight = response.lampData["TG271:c1_b4:i-rmlight-zj"].val;
            this.mantleTopLight = response.lampData["TG271:c1_b3:i-rmlight-q"].val;
            this.mantleBackLight = response.lampData["TG271:c1_b4:i-td-h"].val;

            //状态
            this.isMantleTopLight = response.diStatusData["TG271:c1_b5:di-rmlight-q"].val;//前软膜灯
            this.isCenterLight = response.diStatusData["TG271:c1_b5:di-sd-zj"].val;//中间射灯
            this.isScreenTopLight = response.diStatusData["TG271:c1_b5:di-td-mbq"].val;//幕布前筒灯
            this.isDownFlushLight = response.diStatusData["TG271:c1_b5:di-td-w"].val;//外圈筒灯
            this.isMantleBackLight = response.diStatusData["TG271:c1_b6:di-rmlight-h"].val;//软膜灯后
            this.isMantleCenterLight = response.diStatusData["TG271:c1_b6:di-rmlight-zj"].val;//软膜灯中
            this.isBothLight = response.diStatusData["TG271:c1_b6:di-sd-w"].val;//两侧射灯
            this.isQuadrangleLight = response.diStatusData["TG271:c1_b6:di-td-sj"].val;//四角筒灯
            this.isRollingStatus = response.diStatusData["TG271:c1_b7:di-cl"].val;//窗帘状态
            this.isScreenStatus = response.diStatusData["TG271:c1_b8:di-mb"].val;//幕布状态

            this.addGraphView()
          }).catch((response) => {
        this.addGraphView()
        console.log(response);
      });
    },

    //实时状态
    getStatus() {
      let light = this.g3d.dm().getDataByTag("light");
      let spotlight = this.g3d.dm().getDataByTag("spotlight");
      let lightChild = light.getChildren()._as;
      let spotlightChild = spotlight.getChildren()._as;
      // 会谈
      let meetingTxt = this.graphView.dm().getDataByTag("meetingtxt"),
          mantle = this.g3d.dm().getDataByTag("mantle"),
          mantleTxt = this.dm.getDataByTag("mantletxt"),
          screenLight1 = this.g3d.dm().getDataByTag("screenlight1"),
          screenLight2 = this.g3d.dm().getDataByTag("screenlight2"),
          screenLight3 = this.g3d.dm().getDataByTag("screenlight3"),
          screenLight4 = this.g3d.dm().getDataByTag("screenlight4"),
          screenLight5 = this.g3d.dm().getDataByTag("screenlight5"),
          screenLightTxt = this.dm.getDataByTag("screenlighttxt"),
          spotLight1 = this.g3d.dm().getDataByTag("spotlight1"),
          spotLight2 = this.g3d.dm().getDataByTag("spotlight2"),
          spotLight3 = this.g3d.dm().getDataByTag("spotlight3"),
          spotLight4 = this.g3d.dm().getDataByTag("spotlight4"),
          spotLight5 = this.g3d.dm().getDataByTag("spotlight5"),
          downLightTxt = this.dm.getDataByTag("downlighttxt"),
          reactionTxt = this.graphView.dm().getDataByTag("reactiontxt"),
          lightTxt = this.graphView.dm().getDataByTag("lighttxt");
      let reaction1 = this.g3d.dm().getDataByTag("reaction1"),
          reaction2 = this.g3d.dm().getDataByTag("reaction2"),
          reaction3 = this.g3d.dm().getDataByTag("reaction3"),
          reaction4 = this.g3d.dm().getDataByTag("reaction4");
      //窗帘
      let rollingTxt = this.dm.getDataByTag("rollingtxt"),speed=1,timer,
          rollY1 = this.g3d.dm().getDataByTag("rolling1").getSize3d(), //获取大小
          rollY2 = this.g3d.dm().getDataByTag("rolling2").getSize3d(), //获取大小
          rollY3 = this.g3d.dm().getDataByTag("rolling3").getSize3d(), //获取大小
          roll1 = this.g3d.dm().getDataByTag("rolling1"),
          roll2 = this.g3d.dm().getDataByTag("rolling2"),
          roll3 = this.g3d.dm().getDataByTag("rolling3")

      let curtain = this.g3d.dm().getDataByTag("curtain"),timer1,timer2,
          curtainY = this.g3d.dm().getDataByTag("curtain").getSize3d();
      let shadowTxt = this.dm.getDataByTag("shadowtxt"),
          screenTxt = this.dm.getDataByTag("screentxt");
      let airBoard = this.g3d.dm().getDataByTag("airboard");
      let air = this.g3d.dm().getDataByTag("air");
      let airTxt = this.graphView.dm().getDataByTag("airtxt");
      let airTable = this.graphView.dm().getDataByTag("table1");

      //软膜
      if (this.isMantleTopLight === '0') {
        mantle.s('brightness',1) //设置节点亮度
        mantleTxt.s("text", "开启软膜")
      }else {
        mantle.s('brightness',1.5) //设置节点亮度
        mantleTxt.s("text", "关闭软膜")
      }
      //中间射灯
      if(this.isCenterLight === '1'){
        //4个方型射灯开
        spotLight2.s('3d.visible', false)
        spotLight3.s('3d.visible', false)
        spotLight4.s('3d.visible', false)
        spotLight5.s('3d.visible', false)
      }else {
        //4个方型射灯开
        spotLight2.s('3d.visible', true)
        spotLight3.s('3d.visible', true)
        spotLight4.s('3d.visible', true)
        spotLight5.s('3d.visible', true)
      }

      // 外圈筒灯
      if (this.isDownFlushLight === '0') {
        for (let i in lightChild) {
          lightChild[i].s('3d.visible', false);
        }
        downLightTxt.s("text", "开启外圈筒灯")
      }else {
        for (let i in lightChild) {
          lightChild[i].s('3d.visible', true);
        }
        downLightTxt.s("text", "关闭外圈筒灯")
      }
      //幕布前筒灯
      if (this.isScreenTopLight === '0') {
        //幕布前筒灯关
        screenLight1.s('3d.visible', false)
        screenLight2.s('3d.visible', false)
        screenLight3.s('3d.visible', false)
        screenLight4.s('3d.visible', false)
        screenLight5.s('3d.visible', false)
        screenLightTxt.s("text", "开启幕布前筒灯")
      }else {
        screenLight1.s('3d.visible', true)
        screenLight2.s('3d.visible', true)
        screenLight3.s('3d.visible', true)
        screenLight4.s('3d.visible', true)
        screenLight5.s('3d.visible', true)
        screenLightTxt.s("text", "关闭幕布前筒灯")
      }



      //两侧射灯
      if (this.isBothLight === '0') {
        for (let i in spotlightChild) {
          spotlightChild[i].s('3d.visible', false);
        }
      }else {
        for (let i in spotlightChild) {
          spotlightChild[i].s('3d.visible', true);
        }
        // spotLight2.s('3d.visible', false)
        // spotLight3.s('3d.visible', false)
        // spotLight4.s('3d.visible', false)
        // spotLight5.s('3d.visible', false)
      }

      // 感应
      if (this.isQuadrangleLight === '0') {
        reaction1.s('3d.visible', false)
        reaction2.s('3d.visible', false)
        reaction3.s('3d.visible', false)
        reaction4.s('3d.visible', false)
        reactionTxt.s("text", "开启感应")
      }else {
        reaction1.s('3d.visible', true)
        reaction2.s('3d.visible', true)
        reaction3.s('3d.visible', true)
        reaction4.s('3d.visible', true)
        reaction1.s('envmap', 0.7) //具体图元设置环境光贴图透明度
        reactionTxt.s("text", "关闭感应")
      }

      //卷帘
      if (this.isRollingStatus === '1') {
        roll1.setSize3d(1516, 154, 80)
        roll2.setSize3d(1516, 154, 80)
        roll3.setSize3d(1516, 154, 80)
        rollingTxt.s("text", "降下卷帘")
      }else {
        roll1.setSize3d(1516, 1652, 80)
        roll2.setSize3d(1516, 1652, 80)
        roll3.setSize3d(1516, 1652, 80)
        rollingTxt.s("text", "升起卷帘")
      }

      // 幕布
      if (this.isScreenStatus === '1') {
        curtain.setSize3d(8, 0, 336)
        screenTxt.s("text", "降下幕布")
      }else {
        curtain.setSize3d(8, 248, 336)
        screenTxt.s("text", "升起幕布")
      }

      // 空调
      if (this.ktStatus === '0') {
        airBoard.s('3d.visible', false);
        airTable.s('2d.visible', false);
        airTxt.s("text", "开启空调")
      } else {
        airBoard.s('3d.visible', true);
        airBoard.s('select.brightness',1.5) //设置节点选中亮度
        airTable.s('2d.visible', true);
        let posi = air.p3();
        posi[1] = posi[1] + 100;
        airBoard.p3(posi)
        airTxt.s("text", "关闭空调")
      }

      // 投影
      if (this.isScreenTopLight === '0' && this.isScreenStatus === '0' && this.isRollingStatus === '0' && this.isMantleTopLight === '1') {
        shadowTxt.s("text", "关闭投影")
      }else if (this.isScreenTopLight === '1' && this.isScreenStatus === '1' && this.isRollingStatus === '1' && this.isMantleTopLight === '0'){
        shadowTxt.s("text", "开启投影")

      }
      //照明
      if (this.isCenterLight === '1' && this.isBothLight === '1' && this.isMantleTopLight === '1') {
        lightTxt.s("text", "关闭照明")
      }else {
        lightTxt.s("text", "开启照明")
      }


    },

    // 输入密码按钮
    passwordTest(tag, val, name, func) {
      this.$prompt('请输入密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputErrorMessage: '密码不正确',
        placeholder: "请输入密码"
      }).then((value) => {
        if (!value.value) {
          this.$message({
            type: 'error',
            message: '请输入密码'
          });
          return false;
        } else {
          let psw = this.$md5(value.value);
          this.$post( 'conferenceroom/setsz',{
            tg: this.TG_NAME,
            column: 'user_name',
            operatePassword: psw,
            tag: tag,
            switchStatus: val,
            beforeSwitchStatus: this.beforeSwitchStatus,
            actionObject: name
          }).then((res)=>{
            if(res.indexOf('密码错误') != 0){
              clearInterval(this.timer)
              this.getStatus();
              if (tag.indexOf('c1_b2') !== '0'){
                let _this = this;
                setTimeout(function () {
                  _this.interval()
                },12000)
              }
              if (func) {
                func()
              }
            }
          }).catch((response)=>{
            console.log(response);
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },



    //监听按钮
    handleInteractive2d(e){
      const { kind, data } = e; // 事件类型，
      let px = [665, 720, 774, 828, 882, 936, 990, 1044, 1098, 1152, 1206];
      let icon = this.graphView.dm().getDataByTag("buttonHoverIcon");
      const enter_buttons = ["meeting", "shadow", "energy", "airbtn", "lighting", "reaction", "mantle",  "rolling", "screen", "screenlight", "downlight", "back"];
      const click_buttons = ["meeting", "shadow", "energy", "airbtn", "lighting", "reaction", "mantle",  "rolling", "screen", "screenlight", "downlight", "back"];

      let light = this.g3d.dm().getDataByTag("light");
      let spotlight = this.g3d.dm().getDataByTag("spotlight");
      let lightChild = light.getChildren()._as;
      let spotlightChild = spotlight.getChildren()._as;
      // 会谈
      let meetingTxt = this.graphView.dm().getDataByTag("meetingtxt"),
          mantle = this.g3d.dm().getDataByTag("mantle"),
          mantleTxt = this.dm.getDataByTag("mantletxt"),
          screenLight1 = this.g3d.dm().getDataByTag("screenlight1"),
          screenLight2 = this.g3d.dm().getDataByTag("screenlight2"),
          screenLight3 = this.g3d.dm().getDataByTag("screenlight3"),
          screenLight4 = this.g3d.dm().getDataByTag("screenlight4"),
          screenLight5 = this.g3d.dm().getDataByTag("screenlight5"),
          screenLightTxt = this.dm.getDataByTag("screenlighttxt"),
          spotLight1 = this.g3d.dm().getDataByTag("spotlight1"),
          spotLight2 = this.g3d.dm().getDataByTag("spotlight2"),
          spotLight3 = this.g3d.dm().getDataByTag("spotlight3"),
          spotLight4 = this.g3d.dm().getDataByTag("spotlight4"),
          spotLight5 = this.g3d.dm().getDataByTag("spotlight5"),
          downLightTxt = this.dm.getDataByTag("downlighttxt"),
          reactionTxt = this.graphView.dm().getDataByTag("reactiontxt"),
          lightTxt = this.graphView.dm().getDataByTag("lighttxt");
      //窗帘
      let rollingTxt = this.dm.getDataByTag("rollingtxt"),speed=1,timer,
          rollY1 = this.g3d.dm().getDataByTag("rolling1").getSize3d(), //获取大小
          rollY2 = this.g3d.dm().getDataByTag("rolling2").getSize3d(), //获取大小
          rollY3 = this.g3d.dm().getDataByTag("rolling3").getSize3d(), //获取大小
          roll1 = this.g3d.dm().getDataByTag("rolling1"),
          roll2 = this.g3d.dm().getDataByTag("rolling2"),
          roll3 = this.g3d.dm().getDataByTag("rolling3")
      if (kind === "clickData") {
        let tag = data.getTag();
        // 返回按钮
        if(tag === "back") {
          // this.$router.push('/energyInfo');
          this.$router.back()//返回上一页
        }

        //会谈
        else if (tag === "meeting") {

          //会谈
          this.passwordTest('c1_b1_talk-on', '1', '会谈', talk);
          this.beforeSwitchStatus = '1'
          //动画
          function talk(){
            for (let i in lightChild) {
              lightChild[i].s('3d.visible', false);
            }
            for (let i in spotlightChild) {
              spotlightChild[i].s('3d.visible', false);
            }
            screenLight1.s('3d.visible', true)
            screenLight2.s('3d.visible', true)
            screenLight3.s('3d.visible', true)
            screenLight4.s('3d.visible', true)
            screenLight5.s('3d.visible', true)
            screenLightTxt.s("text", "关闭幕布前筒灯")
            mantle.s('brightness',1.5) //设置节点亮度
            spotLight2.s('3d.visible', true)
            spotLight3.s('3d.visible', true)
            spotLight4.s('3d.visible', true)
            spotLight5.s('3d.visible', true)
            mantleTxt.s("text", "关闭软膜")
            // lightTxt.s("text", "关闭照明")
          }
        }

        //投影
        else if (tag === "shadow") {
          let curtain = this.g3d.dm().getDataByTag("curtain"), timer1, timer2,
              curtainY = this.g3d.dm().getDataByTag("curtain").getSize3d();
          let shadowTxt = this.dm.getDataByTag("shadowtxt"),
              screenTxt = this.dm.getDataByTag("screentxt");
          if (this.isScreenStatus === '1') {
            this.passwordTest('c1_b1_tyms-on', '1', '投影', shadowOn);
            this.beforeSwitchStatus = '1'
            function shadowOn() {
              for (let i in spotlightChild) {
                spotlightChild[i].s('3d.visible', false);
              }
              for (let i in lightChild) {
                lightChild[i].s('3d.visible', true);//筒灯全开
              }
              //幕布前筒灯关
              screenLight1.s('3d.visible', false)
              screenLight2.s('3d.visible', false)
              screenLight3.s('3d.visible', false)
              screenLight4.s('3d.visible', false)
              screenLight5.s('3d.visible', false)
              screenLightTxt.s("text", "开启幕布前筒灯")
              //4个方型射灯开
              spotLight2.s('3d.visible', true)
              spotLight3.s('3d.visible', true)
              spotLight4.s('3d.visible', true)
              spotLight5.s('3d.visible', true)
              mantle.s('brightness',1) //设置节点亮度
              mantleTxt.s("text", "开启软膜")
              //幕布下降
              if (curtainY[1] <= 0) {
                clearInterval(timer1)
                timer1 = setInterval(function (){
                  curtainY[1]++
                  if (curtainY[1] >= 248) {
                    clearInterval(timer1)
                  }
                  curtain.setSize3d(curtainY)
                },100)
              }
              shadowTxt.s("text", "关闭投影")
              screenTxt.s("text", "幕布升起")
              rollingTxt.s("text", "升起卷帘")
              reactionTxt.s("text", "关闭感应")
              // 窗帘下降
              if (rollY1[1] <= 154) {
                clearInterval(timer2)
                timer2 = setInterval(function (){
                  rollY1[1]+=speed
                  rollY2[1]+=speed
                  rollY3[1]+=speed
                  if (rollY1[1] >= 1652) {
                    clearInterval(timer2)
                  }
                  roll1.setSize3d(rollY1)
                  roll2.setSize3d(rollY2)
                  roll3.setSize3d(rollY3)
                },20)
              }
              roll1.setSize3d(rollY1)
              roll2.setSize3d(rollY2)
              roll3.setSize3d(rollY3)
            }

          } else if (this.isScreenStatus === '0') {
            this.passwordTest('c1_b1_tyms-off', '1', '投影', shadowOff);
            this.beforeSwitchStatus = '1'
            function shadowOff() {
              for (let i in spotlightChild) {
                spotlightChild[i].s('3d.visible', false);
              }
              for (let i in lightChild) {
                lightChild[i].s('3d.visible', false);//筒灯全关
              }
              //幕布前筒灯关
              screenLight1.s('3d.visible', true)
              screenLight2.s('3d.visible', true)
              screenLight3.s('3d.visible', true)
              screenLight4.s('3d.visible', true)
              screenLight5.s('3d.visible', true)
              screenLightTxt.s("text", "关闭幕布前筒灯")
              // 幕布上升
              if (curtainY[1] >= 248) {
                clearInterval(timer1)
                timer1 = setInterval(function () {
                  curtainY[1]--
                  if (curtainY[1] <= 0) {
                    clearInterval(timer1)
                  }
                  curtain.setSize3d(curtainY)
                }, 100)
              }
              shadowTxt.s("text", "开启投影")
              screenTxt.s("text", "幕布下降")
              rollingTxt.s("text", "降下卷帘")
              reactionTxt.s("text", "开启感应")
              mantle.s('brightness',1.5) //开启软膜
              // 窗帘上升
              if (rollY1[1] >= 1652) {
                clearInterval(timer2)
                timer2 = setInterval(function () {
                  rollY1[1] -= speed
                  rollY2[1] -= speed
                  rollY3[1] -= speed
                  if (rollY1[1] <= 154) {
                    clearInterval(timer2)
                  }
                  roll1.setSize3d(rollY1)
                  roll2.setSize3d(rollY2)
                  roll3.setSize3d(rollY3)
                }, 20)
              }
            }

          }
        }


        //节能
        else if (tag === "energy") {
          // let spotlightChild = spotlight.getChildren()._as;//射灯
          let lightChild = light.getChildren()._as;//筒灯
          //let energyTxt = this.graphView.dm().getDataByTag("energytxt");

          // if (this.isDownFlushLight === 0) {
          this.passwordTest('c1_b1_jn-on', '1', '节能', energyOn);
          this.beforeSwitchStatus = '1'
          function energyOn(){
            for (let i in lightChild) {
              lightChild[i].s('3d.visible', true);
              lightChild[i].s('envmap', 0.3) //具体图元设置环境光贴图透明度
            }
            downLightTxt.s("text", "关闭外圈筒灯")
            mantle.s('brightness',1) //设置节点亮度
            mantleTxt.s("text", "开启软膜")
            reactionTxt.s("text", "关闭感应")
          }
          // }
        }

        //空调
        else if (tag === "airbtn") {
          let airBoard = this.g3d.dm().getDataByTag("airboard");
          let air = this.g3d.dm().getDataByTag("air");
          let airTxt = this.graphView.dm().getDataByTag("airtxt");
          let airTable = this.graphView.dm().getDataByTag("table1");
          // 制冷
          airBoard.a('funCold',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','3', '空调')
            this.beforeSwitchStatus = '3'
          })
          // 制热
          airBoard.a('funHot',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','4', '空调')
            this.beforeSwitchStatus = '4'
          })
          // 低速
          airBoard.a('funLow',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','5', '空调')
            this.beforeSwitchStatus = '5'
          })
          // 中速
          airBoard.a('funMid',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','6', '空调')
            this.beforeSwitchStatus = '6'
          })
          // 高速
          airBoard.a('funHigh',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','7', '空调')
            this.beforeSwitchStatus = '7'
          })
          // 18℃
          airBoard.a('funEight',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','8', '空调')
            this.beforeSwitchStatus = '8'
          })
          // 19℃
          airBoard.a('funNine',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','9', '空调')
            this.beforeSwitchStatus = '9'
          })
          // 20℃
          airBoard.a('funTwenty',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','10', '空调')
            this.beforeSwitchStatus = '10'
          })
          // 21℃
          airBoard.a('funTwOne',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','11', '空调')
            this.beforeSwitchStatus = '11'
          })
          // 22℃
          airBoard.a('funTwTwo',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','12', '空调')
            this.beforeSwitchStatus = '12'
          })
          // 23℃
          airBoard.a('funTwThree',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','13', '空调')
            this.beforeSwitchStatus = '13'
          })
          // 24℃
          airBoard.a('funTwFour',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','14', '空调')
            this.beforeSwitchStatus = '14'
          })
          // 25℃
          airBoard.a('funTwFive',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','15', '空调')
            this.beforeSwitchStatus = '15'
          })
          // 26℃
          airBoard.a('funTwSix',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','16', '空调')
            this.beforeSwitchStatus = '16'
          })
          // 27℃
          airBoard.a('funTwSeven',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','17', '空调')
            this.beforeSwitchStatus = '17'
          })
          // 28℃
          airBoard.a('funTwEight',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','18', '空调')
            this.beforeSwitchStatus = '18'
          })
          // 29℃
          airBoard.a('funTwNine',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','19', '空调')
            this.beforeSwitchStatus = '19'
          })
          // 30℃
          airBoard.a('funThirty',() => {
            //调用接口
            this.passwordTest('c1_b2_do1','20', '空调')
            this.beforeSwitchStatus = '20'
          })

          if (this.ktStatus === '0') {
            this.passwordTest('c1_b2_do1', '2', '空调', airOn);
            this.beforeSwitchStatus = '2'
            function airOn(){
              airBoard.s('3d.visible', true);
              airBoard.s('select.brightness',1.5) //设置节点选中亮度
              airTable.s('2d.visible', true);
              let posi = air.p3();
              posi[1] = posi[1] + 100;
              airBoard.p3(posi)
              airTxt.s("text", "关闭空调")
            }
            this.ktStatus = 1;
          } else {
            let _this = this;
            this.passwordTest('c1_b2_do1', '1', '空调', airOff);
            this.beforeSwitchStatus = '1'
            function airOff(){
              airBoard.s('3d.visible', false);
              airTable.s('2d.visible', false);
              airTxt.s("text", "开启空调")
              _this.interval();
            }
            this.ktStatus = '0';
          }
        }

        //照明
        else if (tag === "lighting") {
          let lightChild = light.getChildren()._as;
          // let spotlightChild = spotlight.getChildren()._as;
          let lightTxt = this.graphView.dm().getDataByTag("lighttxt");
          let mantle = this.g3d.dm().getDataByTag("mantle");

          if (this.isCenterLight === '0') {
            this.passwordTest('c1_b1_light-on', '1', '照明', lightingOn);
            this.beforeSwitchStatus = '1'
            function lightingOn(){
              mantle.s('brightness',1.5) //设置节点亮度
              for (let i in lightChild) {
                lightChild[i].s('3d.visible', true);
              }
              for (let i in spotlightChild) {
                spotlightChild[i].s('3d.visible', true);
              }
              lightTxt.s("text", "关闭照明")
              mantleTxt.s("text", "关闭软膜")
              screenLightTxt.s("text", "关闭幕布前筒灯")
              downLightTxt.s("text", "关闭外圈筒灯")
              reactionTxt.s("text", "关闭感应")
            }
          } else {
            this.passwordTest('c1_b1_light-off', '1', '照明', lightingOff);
            this.beforeSwitchStatus = '1'
            function lightingOff(){
              mantle.s('brightness',1) //设置节点亮度
              for (let i in lightChild) {
                lightChild[i].s('3d.visible', false);
              }
              for (let i in spotlightChild) {
                spotlightChild[i].s('3d.visible', false);
              }
              lightTxt.s("text", "开启照明")
              mantleTxt.s("text", "开启软膜")
              screenLightTxt.s("text", "开启幕布前筒灯")
              downLightTxt.s("text", "开启外圈筒灯")
              reactionTxt.s("text", "开启感应")
            }
          }
        }

        //感应
        else if (tag === "reaction") {
          let reactionTxt = this.graphView.dm().getDataByTag("reactiontxt");
          let reaction1 = this.g3d.dm().getDataByTag("reaction1"),
              reaction2 = this.g3d.dm().getDataByTag("reaction2"),
              reaction3 = this.g3d.dm().getDataByTag("reaction3"),
              reaction4 = this.g3d.dm().getDataByTag("reaction4");

          if (this.isQuadrangleLight === '0') {
            this.passwordTest('c1_b1_gy-on', '1', '感应', reactionOn);
            this.beforeSwitchStatus = '1'
            function reactionOn(){
              reaction1.s('3d.visible', true)
              reaction2.s('3d.visible', true)
              reaction3.s('3d.visible', true)
              reaction4.s('3d.visible', true)
              reaction1.s('envmap', 0.7) //具体图元设置环境光贴图透明度

              reactionTxt.s("text", "关闭感应")
            }
          } else {
            this.passwordTest('c1_b1_gy-off', '1', '感应', reactionOff);
            this.beforeSwitchStatus = '1'
            function reactionOff(){
              reaction1.s('3d.visible', false)
              reaction2.s('3d.visible', false)
              reaction3.s('3d.visible', false)
              reaction4.s('3d.visible', false)
              reaction1.s('envmap', 1) //具体图元设置环境光贴图透明度
              reactionTxt.s("text", "开启感应")
            }
          }
        }

        //软膜
        else if (tag === "mantle") {
          let mantleTxt = this.dm.getDataByTag("mantletxt"),
              mantle = this.g3d.dm().getDataByTag("mantle");

          if (this.isMantleTopLight === '0') {
            this.passwordTest('c1_b1_rmlight-on', '1', '软膜', mantleOn);
            this.beforeSwitchStatus = '1'
            function mantleOn(){
              mantle.s('brightness',1.5) //设置节点亮度
              mantleTxt.s("text", "关闭软膜")
            }
          } else {
            this.passwordTest('c1_b1_rmlight-off', '1', '软膜', mantleOff);
            this.beforeSwitchStatus = '1'
            function mantleOff(){
              mantle.s('brightness',1) //设置节点亮度
              mantleTxt.s("text", "开启软膜")
            }
          }
        }

        //卷帘
        else if (tag === "rolling") {

          if (this.isRollingStatus === '1') {
            this.passwordTest('c1_b1_cl-down', '1', '卷帘', rollingDown);
            this.beforeSwitchStatus = '1'
            function rollingDown(){
              rollingTxt.s("text", "升起卷帘")
              if (rollY1[1] <= 154) {
                clearInterval(timer)
                timer = setInterval(function (){
                  rollY1[1]+=speed
                  rollY2[1]+=speed
                  rollY3[1]+=speed
                  if (rollY1[1] >= 1652) {
                    clearInterval(timer)
                  }
                  roll1.setSize3d(rollY1)
                  roll2.setSize3d(rollY2)
                  roll3.setSize3d(rollY3)
                },20)
              }
              roll1.setSize3d(rollY1)
              roll2.setSize3d(rollY2)
              roll3.setSize3d(rollY3)
            }
          } else {
            this.passwordTest('c1_b1_cl-top', '1', '卷帘', rollingTop);
            this.beforeSwitchStatus = '1'
            function rollingTop(){
              if (rollY1[1] >= 1652) {
                clearInterval(timer)
                timer = setInterval(function (){
                  rollY1[1]-=speed
                  rollY2[1]-=speed
                  rollY3[1]-=speed
                  if (rollY1[1] <= 154) {
                    clearInterval(timer)
                  }
                  roll1.setSize3d(rollY1)
                  roll2.setSize3d(rollY2)
                  roll3.setSize3d(rollY3)
                },20)
              }
              rollingTxt.s("text", "降下卷帘")
            }
          }
        }

        //幕布
        else if (tag === "screen") {
          let curtain = this.g3d.dm().getDataByTag("curtain"), timer,
              curtainY = this.g3d.dm().getDataByTag("curtain").getSize3d();
          let screenTxt = this.dm.getDataByTag("screentxt");

          if (this.isScreenStatus === '1') {
            this.passwordTest('c1_b1_mb-down', '1', '幕布', screenDown);
            this.beforeSwitchStatus = '1'
            function screenDown() {
              if (curtainY[1] <= 0) {
                clearInterval(timer)
                timer = setInterval(function () {
                  curtainY[1]++
                  if (curtainY[1] >= 248) {
                    clearInterval(timer)
                  }
                  curtain.setSize3d(curtainY)
                }, 100)
              }
              //curtain.s('3d.visible', false);
              screenTxt.s("text", "升起幕布")
            }
          } else {
            this.passwordTest('c1_b1_mb-top', '1', '幕布', screenTop);
            this.beforeSwitchStatus = '1'
            function screenTop() {
              if (curtainY[1] >= 248) {
                clearInterval(timer)
                timer = setInterval(function () {
                  curtainY[1]--
                  if (curtainY[1] <= 0) {
                    clearInterval(timer)
                  }
                  curtain.setSize3d(curtainY)
                }, 100)
              }
              curtain.s('3d.visible', true);
              screenTxt.s("text", "降下幕布")
            }
          }
        }

        //前筒灯
        else if (tag === "screenlight") {
          let screenLight1 = this.g3d.dm().getDataByTag("screenlight1"),
              screenLight2 = this.g3d.dm().getDataByTag("screenlight2"),
              screenLight3 = this.g3d.dm().getDataByTag("screenlight3"),
              screenLight4 = this.g3d.dm().getDataByTag("screenlight4"),
              screenLight5 = this.g3d.dm().getDataByTag("screenlight5");
          let screenLightTxt = this.dm.getDataByTag("screenlighttxt");

          if (this.isScreenTopLight === '0') {
            this.passwordTest('c1_b1_mbqtd-on', '1', '前筒灯', screenLightOn);
            this.beforeSwitchStatus = '1'
            function screenLightOn(){
              screenLight1.s('3d.visible', true)
              screenLight2.s('3d.visible', true)
              screenLight3.s('3d.visible', true)
              screenLight4.s('3d.visible', true)
              screenLight5.s('3d.visible', true)
              screenLightTxt.s("text", "关闭幕布前筒灯")
            }
          } else {
            this.passwordTest('c1_b1_mbqtd-off', '1', '前筒灯', screenLightOff);
            this.beforeSwitchStatus = '1'
            function screenLightOff() {
              screenLight1.s('3d.visible', false)
              screenLight2.s('3d.visible', false)
              screenLight3.s('3d.visible', false)
              screenLight4.s('3d.visible', false)
              screenLight5.s('3d.visible', false)
              screenLightTxt.s("text", "开启幕布前筒灯")
            }
          }
        }

        //外圈筒灯
        else if (tag === "downlight") {
          let downLightTxt = this.dm.getDataByTag("downlighttxt");
          let lightChild = light.getChildren()._as;

          if (this.isDownFlushLight === '0') {
            this.passwordTest('c1_b1_wqtd-on', '1', '外圈筒灯', downLightOn);
            this.beforeSwitchStatus = '1'
            function downLightOn(){
              for (let i in lightChild) {
                lightChild[i].s('3d.visible', true);
              }
              screenLightTxt.s("text", "关闭幕布前筒灯")
              reactionTxt.s("text", "关闭感应")
              downLightTxt.s("text", "关闭外圈筒灯")
            }
          } else {
            this.passwordTest('c1_b1_wqtd-off', '1', '外圈筒灯', downLightOff);
            this.beforeSwitchStatus = '1'
            function downLightOff(){
              for (let i in lightChild) {
                lightChild[i].s('3d.visible', false);
              }
              screenLightTxt.s("text", "开启幕布前筒灯")
              reactionTxt.s("text", "开启感应")
              downLightTxt.s("text", "开启外圈筒灯")
            }
          }
        }
      } else if (kind === "onEnter") {
        let tag = data.getTag();
        let index = click_buttons.indexOf(tag);

        // 添加图标下面的蓝色方块
        if (index > -1) {
          icon.setX(px[index]);
        }
        // 鼠标移入变小手
        if (enter_buttons.indexOf(tag) > -1) {
          this.graphView.getView().style.cursor = "pointer";
        }
      } else if (kind === "onLeave") {}
    },

  }
}
</script>

<style scoped>

</style>
